import NiceModal from "@ebay/nice-modal-react";
import ContactUsModal from "modals/ContactUsModal";
import ContactUsSendingModal from "modals/ContactUsSendingModal";
import ProductDetailModal from "modals/ProductDetailModal";
import SideMenu from "modals/sideMenu/SideMenu";
import LiquidSideMenu from "modals/sideMenu/LiquidSideMenu";

function ModalHandler() {
    NiceModal.register("productDetailModal", ProductDetailModal);
    NiceModal.register("contactUsModal", ContactUsModal);
    NiceModal.register("contactUsSendingModal", ContactUsSendingModal);
    NiceModal.register("sideMenu", SideMenu);
    NiceModal.register("liquidSideMenu", LiquidSideMenu);
    // NiceModal.register("userAddressModal", UserAddressModal);
    // NiceModal.register("paymentModal", PaymentModal);
    // NiceModal.register("sideMenu", SideMenu);
    // NiceModal.register("shippingInfoAddModal", ShippingInfoAddModal);
    
}

export default ModalHandler;